import React from "react";
import { Info } from "lucide-react";

interface InfoBannerProps {
  children: React.ReactNode;
  className?: string;
}

export function InfoBanner({ children, className = "" }: InfoBannerProps) {
  return (
    <div className={`bg-gray-100 rounded-lg p-4 mb-4 border border-gray-300 ${className}`}>
      <p className="text-sm text-gray-700 flex items-start">
        <Info className="h-4 w-4 mr-2 text-blue-600 mt-0.5 flex-shrink-0" />
        {children}
      </p>
    </div>
  );
} 